<template>
  <el-card class="box-card order-detail-section mg20">
    <div slot="header" class="clearfix">
      <span>学校规模</span>
    </div>
    <div>
      <el-row>
        班级数：{{ order.class_num }}        教师数：{{ order.teacher_num }}
      </el-row>
    </div>
  </el-card>
</template>

<script>
export default {
  name: "order_scale",
  props: {
    order: {
      required: true,
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/order/partial/order_scale.vue